import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { AuthGuard } from '../auth/services/auth-guard-service'
import { SalesRepGuard } from '../auth/services/sales-rep-guard-service'

import { OrderhistoryPageContainerComponent } from './containers/orderhistory-page-container/orderhistory-page-container.component'
import { OrderhistorylinesPageContainerComponent } from './containers/orderhistorylines-page-container/orderhistorylines-page-container.component';

const routes: Routes = [
  {
    path: 'orderhistory',
    canActivate: [AuthGuard, SalesRepGuard],
    component: OrderhistoryPageContainerComponent
  },
  {
    path: 'orderhistory/:ordernumber',
    canActivate: [AuthGuard, SalesRepGuard],
    component: OrderhistorylinesPageContainerComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderHistoryRoutingModule { }
